module.exports = __webpack_public_path__ + "img/reezocar-logo-1@2x.2c5eb701.webp";